<template>
<Row type="flex" justify="center" align="middle" style="height:100vh;">
  <Col span="8">
    <Card style="width:100%">
      <Form ref="formInline" :model="formItem" inline @submit.native.prevent="go(formItem.input)">
        <FormItem style="width:100%;" @submit.native.prevent="">
          <Input  v-model="formItem.input" placeholder="Enter the event code" @on-enter="go(formItem.input)" >
           <Button type="primary" @click="go(formItem.input)" slot="append">Enter</Button>
          </Input>
        </FormItem>
        <FormItem>

          </FormItem>
      </Form>
    </Card>
  </Col>
</Row>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import {
  mapState,
  mapGetters,
  mapActions
} from 'vuex'



export default {
  name: 'home',
  components: {
    Navbar
  },
  data() {
    return {
      isReady: false,
      formItem: {}
    }
  },
  methods: {
    go(shortLink){
      this.$router.replace(shortLink+'/landing')
    }
  }

}
</script>
